import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';

import { AngularMaterialCommonModule } from '@app/shared/angular-material/angular-material-common.module';

@Component({
  selector: 'app-ext-header',
  templateUrl: './ext-header.component.html',
  styleUrls: ['./ext-header.component.scss'],
  imports: [CommonModule, AngularMaterialCommonModule]
})
export class ExtHeaderComponent {
  isTypeMenuOpen: boolean;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  navigateToExternalURL(url: string) {
    this.document.location.href = url;
  }
}
